import { render, staticRenderFns } from "./ProductsCart.vue?vue&type=template&id=386321fe&scoped=true"
import script from "./ProductsCart.js?vue&type=script&lang=js&external"
export * from "./ProductsCart.js?vue&type=script&lang=js&external"
import style0 from "./ProductsCart.scss?vue&type=style&index=0&id=386321fe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386321fe",
  null
  
)

export default component.exports